import React, { useEffect } from 'react'
import useProfileStore from '../../store/patient/profileStore'
import useManageBills from '../../hooks/patientDashboard/useManageBills';
import Spinner1 from './spinners';
import moment from 'moment';
import { formatCurrency } from '../../utils/utilities';

const TransactionsSidebar = () => {
    

  const { userBills, loading, findPatientBills} = useManageBills();

    const {profile} = useProfileStore()
  useEffect(() => {
    findPatientBills(profile?.id)
  }, [])

  // console.log(userBills?.result)
  const data = userBills?.result;
  
  // console.log(data, 'data')
  return (
    <div className='mt-5'>
     <h5 className={` section-title`}>Recent Transactions</h5>
           
           {
               loading ? ( <div className="w-100 d-flex justify-content-center"><Spinner1 /></div> ) :

              !loading && !data?.length?
           
           <div className='w-100 d-flex justify-content-center'>No Result Found</div>
           :
             data?.slice(0,5)?.map((item, index)=>(
               <div key={index} className="card card-task">
                   <div
                       className="card-body p-3 pb-1"
                       style={{ border: "1px solid lavender", borderRadius: 3 }}
                   >
                       <span className="badge bg-danger" style={{textTransform:'capitalize'}}>{item?.bill_source}</span>
                       &nbsp;
                       <span className="badge bg-primary" style={{textTransform:'capitalize'}}>{item?.transaction_type}</span>
                       <div className="d-flex flex-row-reverse align-items-center justify-content-between mt-2 mb-1">
                           <span className="card-date">{moment(item?.createdAt).format('ddd MMM, YYYY')}</span>
                           <h6 className="card-title">{item?.patientRequestItem?.drug?.name || item?.service?.item?.name}</h6>
                       </div>
                       <p className="fs-xs" style={{textTransform:'capitalize'}}>
                       Amount: <a href="">{formatCurrency(item?.amount)}</a>
                       </p>
                   </div>
               </div>
               )) 
          }

</div>
  )
}

export default TransactionsSidebar